import { ConfigInterface } from "./models/Config.interface";

import config from "@/data/config.json";

export const antaresConfig: ConfigInterface = config as ConfigInterface;

export const useAntaresConfig = (): ConfigInterface => {
  return antaresConfig;
};
